var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNavbar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-navbar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.613,
    height: 27.797,
    viewBox: "0 0 98.613 27.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M291.261,306.918c-.008,1.329-.012,2.622-.009,3.761h9.772c0-1.139,0-2.431-.012-3.761Z",
    transform: "translate(-289.767 -292.599)",
    fill: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M291.351,296.111c-.015,1.158-.03,2.447-.042,3.76h9.72c-.013-1.313-.028-2.6-.043-3.76Z",
    transform: "translate(-289.798 -286.736)",
    fill: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M298.17,278.068h-2.1v-2.413c-.557-.023-1.12-.037-1.7-.037s-1.141.013-1.7.037v2.413h-2.1V275.8c-.907.089-1.766.2-2.558.348,0,0-.012.012-.012.021a17.21,17.21,0,0,0,.366,3.7l1.255,1.351s-.018,1.031-.039,2.59h9.58c-.023-1.559-.042-2.59-.042-2.59l1.254-1.351a17.219,17.219,0,0,0,.365-3.7.036.036,0,0,0-.011-.021c-.791-.146-1.65-.259-2.558-.348Z",
    transform: "translate(-288 -275.619)",
    fill: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M291.405,319.823a17.815,17.815,0,0,0,4.747.649,22.37,22.37,0,0,0,4.751-.649,9.806,9.806,0,0,0,.121-2.1h-9.742A9.855,9.855,0,0,0,291.405,319.823Z",
    transform: "translate(-289.784 -298.464)",
    fill: "#f9f9fa"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(20.001 0.112)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 2.55,
    height: 15.7,
    transform: "translate(0.06 5.949)",
    fill: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M354.307,288.15a8.414,8.414,0,0,0-5.876,2.678v-2.35h-2.583v15.7h2.583v-11.3c1.633-1.547,3.2-2.527,5.075-2.527,1.989,0,2.879.98,2.879,3.06v10.765h2.552V292.852C358.937,289.875,357.3,288.15,354.307,288.15Z",
    transform: "translate(-339.439 -282.529)",
    fill: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M383.893,276.648h-2.552v5.59h-2.73v2.111h2.73v9.782c0,2.739,1.069,4.016,4.363,4.016a14.081,14.081,0,0,0,2.226-.179v-2.11a6.453,6.453,0,0,1-1.6.21c-1.9,0-2.434-.835-2.434-2.5v-9.22h4.066v-2.111h-4.066Z",
    transform: "translate(-357.245 -276.289)",
    fill: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M409.821,288.15c-3.295,0-7.094,2.471-7.094,8.178,0,5.47,3.383,8.178,7.094,8.178a7.291,7.291,0,0,0,6.38-3.331l-1.483-1.309A5.3,5.3,0,0,1,410,302.426c-2.584,0-4.629-1.9-4.719-5.443h11.068v-.535C416.348,290.769,413.53,288.15,409.821,288.15Zm-4.482,6.841c.355-3.242,2.344-4.7,4.451-4.7,2.582,0,3.917,1.9,4.126,4.7Z",
    transform: "translate(-370.351 -282.529)",
    fill: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M442.219,288.15c-3.738,0-6.38,2.352-6.38,5.651a5.2,5.2,0,0,0,2.405,4.52,3.247,3.247,0,0,0-1.958,2.528,2.068,2.068,0,0,0,1.334,1.994c-1.75.681-2.85,1.87-2.85,3.477,0,2.379,2.286,3.894,7.57,3.894,4.54,0,7.656-1.576,7.656-4.548,0-2.529-2.019-3.807-5.995-4.075l-3.206-.267c-1.66-.149-2.165-.444-2.165-1.1,0-.536.445-.922,1.1-1.221a8.439,8.439,0,0,0,2.493.387c3.651,0,6.322-2.2,6.322-5.592a4.647,4.647,0,0,0-.8-2.706,8.1,8.1,0,0,1,2.82-.506v-2.26a8.312,8.312,0,0,0-3.71,1.458A6.876,6.876,0,0,0,442.219,288.15Zm-2.76,15.2c.3.032.595.058.892.089l2.967.206c3.295.241,4.333.864,4.333,2.26,0,1.427-1.87,2.38-4.986,2.38-3.887,0-5.52-.774-5.52-2.349C437.145,304.863,437.946,303.884,439.46,303.348Zm2.789-5.83c-2.4,0-3.975-1.4-3.975-3.657s1.513-3.718,3.946-3.718c2.523,0,3.946,1.428,3.946,3.718C446.166,296.122,444.655,297.518,442.249,297.518Z",
    transform: "translate(-387.765 -282.529)",
    fill: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M479.383,288.15c-3.857,0-7.3,2.765-7.3,8.178,0,5.383,3.472,8.178,7.3,8.178s7.271-2.8,7.271-8.178C486.654,290.915,483.212,288.15,479.383,288.15Zm0,14.184c-3.174,0-4.717-2.674-4.717-6.005,0-3.538,1.72-5.976,4.717-5.976,3.116,0,4.689,2.7,4.689,5.976C484.072,299.927,482.352,302.334,479.383,302.334Z",
    transform: "translate(-408.043 -282.529)",
    fill: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M334.482,277.2a1.336,1.336,0,1,1-1.336-1.339A1.338,1.338,0,0,1,334.482,277.2Z",
    transform: "translate(-331.81 -275.863)",
    fill: "#f9f9fa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNavbar);
export default __webpack_public_path__ + "static/media/logo-navbar.7061abb28c6407b73daac1bf4aa60352.svg";
export { ForwardRef as ReactComponent };